
import Vue from "vue";
import {Dossier} from "@/models/dossier/dossier";
import {DossierService} from "@/services/dossier-service";
import AppCountryCodeAutocomplete from "@/components/CountryCodeAutocomplete.vue";
import {AuthService} from "@/services/auth-service";
import AppDossierEditAutoFillModal, {
	IAutoFillSelectedFields
} from "@/components/settings-default/DossierEditAutoFillModal.vue";
import {ContactAutofill} from "@/models/contact-autofill";
import {AllContactsService} from "@/services/all-contacts-service";
import {BankService, DossierConfigService} from "@/services";
import {BankType} from "@/models/base";

export default Vue.extend({
	data() {
		return {
			BankService,
			value: new Dossier(),
			step: 1,
			autoFillData: null as null | ContactAutofill,
			hasError: {
				name: false,
				vatNumber: false,
				streetName: false,
				streetNumber: false,
				cityName: false,
				postalCode: false,
				countryCode: false,
				phone: false,
				email: false,
			} ,
			settings: DossierConfigService.getPluginConfig(),
		};
	},
	computed: {
		title(): string {
			return this.$ct("complete-peppol-settings").toString();
		},
		filteredBankTypes():BankType[] {
			let ibanInput = this.settings.UBL.PeppolIban.toLowerCase().trim();
			return this.BankService.getTypes().filter(t => {
				if (!t.Iban || !t.Bic) return false;
				return t.Iban.toLowerCase().trim().match(ibanInput) != null;
			});
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async finish(){
			await DossierConfigService.savePluginConfig(this.settings);
			this.$emit("finish");
		},
		peppolIbanClicked(bank:BankType){
			this.settings.UBL.PeppolIban = bank.Iban || "";
			this.settings.UBL.PeppolBic =  bank.Bic || "";
		},
		validate():boolean{
			(Object.keys(this.hasError) as any[]).forEach(key => {
				(this.hasError as any)[key] = false;
			});
			if (!this.value.name) this.hasError.name = true;
			if (!this.value.vatNumber) this.hasError.vatNumber = true;
			if (!this.value.streetName) this.hasError.streetName = true;
			if (!this.value.streetNumber) this.hasError.streetNumber = true;
			if (!this.value.cityName) this.hasError.cityName = true;
			if (!this.value.postalCode) this.hasError.postalCode = true;
			if (!this.value.countryCode) this.hasError.countryCode = true;
			if (!this.value.email) this.hasError.email = true;
			if (!this.value.phone) this.hasError.phone = true;
			const hasAnyError = Object.values(this.hasError).some(v => v);
			return !hasAnyError;
		},
		async save() {

			if(!this.validate()){
				return false;
			}
			if (this.value.id) {
				this.value = await DossierService.updateDossier(this.value);
				this.step++;
			}
		},
		async onVatBlur() {
			try {
				this.autoFillData = await AllContactsService.autoFill(this.value.vatNumber);
			} catch (err) {
			}
		},
		autoFill(data: IAutoFillSelectedFields) {
			if (!this.autoFillData) return;
			if (data.address) {
				let split = ContactAutofill.splitAddressIntoAddressAndNumber(this.autoFillData.address || "");
				this.value.streetName = split.address;
				this.value.streetNumber = split.nr;
			}
			if (data.postal) {
				this.value.postalCode = this.autoFillData.postal || this.value.postalCode;
			}
			if (data.city) {
				this.value.cityName = this.autoFillData.city || this.value.cityName;
			}
			if (data.tel) {
				this.value.phone = this.autoFillData.tel || this.value.phone;
			}
			if (data.companyName) {
				this.value.name = this.autoFillData.maatschappelijkeNaam || this.value.name;
			}
		}
	},
	async created() {
		let id = AuthService.wfDossier.id;
		if (id != 0) {
			this.value = await DossierService.getDossier(id);
		}
	},
	components: {
		AppCountryCodeAutocomplete,
		AppDossierEditAutoFillModal
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
